// eslint-disable-next-line no-restricted-imports
import { useMemo, useRef } from 'react';

import { useLegalClientVersions } from 'api/requests';

export const useLegalClientHeadVersions = (
  legalClientId: string,
  headId: string,
  versionId?: string
) => {
  const savedVersionId = useRef(versionId).current;
  const { loading, versions, error } = useLegalClientVersions(legalClientId);

  const filteredVersions = useMemo(() => {
    const currentVersion = versions
      ? Math.max(...versions.map((v) => v.number))
      : undefined;

    return versions?.filter((version) => {
      if (version.updatedEntity.id === headId) {
        return true;
      }

      return (
        version.number === currentVersion ||
        version.number === 1 ||
        version.id === savedVersionId
      );
    });
  }, [headId, savedVersionId, versions]);

  return { loading, versions: filteredVersions, error };
};
